<script setup lang="ts">
import HeaderLayout from '@/layouts/HeaderLayout.vue';
import RouteNameEnum from '@/router/routeNameEnum';
import ButtonColorEnum from '@/domains/common/typescript/ButtonColorEnum';
import { logout } from '@/domains/authentication/services/authenticate';
import IconArrowTopRightSquare from '@/domains/common/components/icons/IconArrowTopRightSquare.vue';
import MenuDropdown from '@/domains/common/components/MenuDropdown.vue';
import TheSelectOfficeHeader from '@/domains/authentication/components/TheSelectOfficeHeader.vue';
import useAuthStore from '@/domains/authentication/store/auth.store';
import { storeToRefs } from 'pinia';

const authStore = useAuthStore();

const { isAdminErgo } = storeToRefs(authStore);
</script>
<template>
    <HeaderLayout>
        <template #navSection="{ isMenuDisabled }">
            <BaseButtonRouterLink
                :to="{ name: RouteNameEnum.AdminOffice }"
                :class="[
                    'transition-colors duration-300 ease-in-out',
                    isMenuDisabled && 'pointer-events-none opacity-50',
                ]"
                active-class="text-primary! font-bold!"
                :color="ButtonColorEnum.Menu"
                :label="$t('menu.office', isAdminErgo ? 2 : 1)"
            />
            <BaseButtonRouterLink
                :to="{ name: RouteNameEnum.AdminUser }"
                :class="[
                    'px-4 font-semibold transition-colors duration-300 ease-in-out',
                    isMenuDisabled && 'pointer-events-none opacity-50',
                ]"
                active-class="text-primary! font-bold!"
                :color="ButtonColorEnum.Menu"
                :label="$t('menu.user', 2)"
            />
            <BaseButtonRouterLink
                :to="{ name: RouteNameEnum.AdminAnnouncement }"
                :class="[
                    'px-4 font-semibold transition-colors duration-300 ease-in-out',
                    isMenuDisabled && 'pointer-events-none opacity-50',
                ]"
                active-class="text-primary! font-bold!"
                :color="ButtonColorEnum.Menu"
                :label="$t('menu.announcement')"
            />
            <BaseButtonRouterLink
                :to="{ name: RouteNameEnum.AdminCatalog }"
                :class="[
                    'px-4 font-semibold transition-colors duration-300 ease-in-out',
                    isMenuDisabled && 'pointer-events-none opacity-50',
                ]"
                active-class="text-primary! font-bold!"
                :color="ButtonColorEnum.Menu"
                :label="$t('menu.admin_catalog')"
            />
            <BaseButtonRouterLink
                :to="{ name: RouteNameEnum.AdminOrders }"
                :class="[
                    'px-4 font-semibold transition-colors duration-300 ease-in-out',
                    isMenuDisabled && 'pointer-events-none opacity-50',
                ]"
                active-class="text-primary! font-bold!"
                :color="ButtonColorEnum.Menu"
                :label="$t('menu.orders')"
            />
        </template>
        <template #menuSection="{ isMenuLarge, isMenuDisabled }">
            <div :class="[isMenuLarge ? 'pr-0' : 'pr-14', 'flex items-center']">
                <MenuDropdown :class="[isMenuDisabled && 'pointer-events-none opacity-50', 'min-w-32']">
                    <template #buttonBody>
                        <span>{{ $t('menu.my_account') }}</span>
                    </template>
                    <template #dropdownList>
                        <BaseButton
                            :label="$t('menu.logout')"
                            :color="ButtonColorEnum.Menu"
                            @click="logout({ shouldLoginRedirect: true })"
                        />
                    </template>
                </MenuDropdown>
                <BaseLink
                    link="https://www.ergorecherche.fr/aide_podofit/"
                    :class="[
                        'hover:text-secondary px-4 font-semibold transition-colors duration-300 ease-in-out',
                        isMenuDisabled && 'pointer-events-none opacity-50',
                    ]"
                    :color="ButtonColorEnum.Menu"
                    :label="$t('menu.help')"
                    :icon="IconArrowTopRightSquare"
                />
            </div>
            <TheSelectOfficeHeader :expanded-menu="isMenuLarge" />
        </template>
    </HeaderLayout>
</template>
